module.exports = __webpack_public_path__ + "static/media/ Cognitive7a5be139.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/ Cognitive.svg
// module id = 1297
// module chunks = 0